import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { CONTACT } from "./data";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Cleaners", href: "#cleaners" },
  { label: "Reviews", href: "#reviews" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50"
    >
      <div className={`transition-all duration-500 ${scrolled ? "bg-white/85 backdrop-blur-md shadow-[0_8px_30px_rgba(2,71,157,0.07)]" : "bg-white/60 backdrop-blur-sm"}`}>
        <nav aria-label="Primary" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Aid in Clean home" className="flex items-center gap-2.5 group">
            <img src="/logo-icon.png" alt="" aria-hidden="true" className="h-11 w-auto transition-transform duration-500 group-hover:scale-105" />
            <span className="font-heading font-extrabold text-xl text-brand-blue">Aid <span className="text-brand-green">in</span> Clean</span>
          </button>

          <div className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <button key={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`} onClick={() => go(l.href)} className="text-sm font-bold text-brand-ink2 hover:text-brand-blue transition-colors duration-300 relative after:absolute after:left-0 after:-bottom-1.5 after:h-1 after:w-0 hover:after:w-full after:rounded-full after:bg-brand-green after:transition-all after:duration-300">
                {l.label}
              </button>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a href={CONTACT.phoneHref} data-testid="nav-phone-link" className="flex items-center gap-2 text-sm font-bold text-brand-blue hover:text-brand-bluehover transition-colors">
              <Phone className="h-4 w-4" strokeWidth={2} aria-hidden="true" /> {CONTACT.phone}
            </a>
            <button data-testid="nav-quote-btn" onClick={() => go("#quote")} className="rounded-full bg-brand-blue text-white text-sm font-bold px-5 py-2.5 hover:bg-brand-bluehover transition-colors duration-300">
              Get a free quote
            </button>
          </div>

          <button data-testid="nav-menu-toggle" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-label={open ? "Close menu" : "Open menu"} className="md:hidden grid place-items-center h-11 w-11 rounded-xl text-brand-blue">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </nav>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="md:hidden overflow-hidden bg-white border-b border-brand-line">
            <div className="px-6 py-6 flex flex-col gap-4">
              {LINKS.map((l) => (<button key={l.href} onClick={() => go(l.href)} className="text-left text-base font-bold text-brand-ink2">{l.label}</button>))}
              <a href={CONTACT.phoneHref} className="text-base font-bold text-brand-blue">{CONTACT.phone}</a>
              <button onClick={() => go("#quote")} className="rounded-full bg-brand-blue text-white text-sm font-bold px-5 py-3">Get a free quote</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
